import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import React from "react";

const Terms = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
        <div className="container-fixed">
           <div className="card">
            terms and condition
           </div>
            </div>
        </main>
      </div>
    </div>
  );
};

export default Terms;
